import React, { useState, useMemo, useEffect } from 'react';
import { Button, Card, Col, Container, Form, Modal, Offcanvas, Row, ListGroup, InputGroup } from 'react-bootstrap';
import Breadcrumb from '../../Common/BreadCrumb';
import TableContainer from "../../Common/TableContainer";
import { useDeletesizeMutation, useSizelistMutation } from '../../Redux/SizeSlice';
import { getQueryString } from "../../lib/Validationtext";
import moment from "moment";
import DeleteModal from '../../Common/modals/DeleteModal';
import { toast } from 'react-toastify'
import { useDelete_faqMutation, useFaqlistQuery } from '../../Redux/faqSlice';
import { useNewsletterlistQuery } from '../../Redux/newsletter/NewsLetterSlice';

const NewsLetterList = () => {
    document.title = "NewsLetters | Toner eCommerce + Admin React Template";
    // const [SizelistFunc, { data: listData, isLoading: listLoading }] = useSizelistMutation();

    const [faqDeleteFunc, { data: deleteData, error: deleteErr, isLoading: deleteLoading, isSuccess: DeleteSuccess }] = useDelete_faqMutation()
    const [faqData, setfaqData] = useState(false);
    const [showCoupons, setShowCoupons] = useState(false);
    const [open, setOpen] = useState(false);
    const [openType, setOpenType] = useState(false);
    const [showModal, setShowModal] = useState(false);

    const [page, setPage] = useState(0);
    const [limit, setlimit] = useState(10);

    const { data: listData, isLoading: listLoading } = useNewsletterlistQuery(getQueryString({ page: page + 1, limit: limit }));


    useEffect(() => {
        if (DeleteSuccess) {
            setShowModal(false)
            const message = deleteData?.message || "Delete successfully";
            toast.success(message);
            setfaqData({})
            // SizelistFunc(getQueryString({ page: page + 1, limit: limit }))

        }
        // if (deleteErr) {
        //     if ('data' in deleteErr) {
        //         const errorData = error;
        //         toast.error(errorData.data.message);

        //     }
        // }
    }, [deleteData, DeleteSuccess, deleteErr]);
    // useEffect(() => {
    //   // SizelistFunc(getQueryString({ page: page + 1, limit: limit }))
    // }, [page, limit, DeleteSuccess, open])

    const columns = [
        {

            Header: "Email",
            disableFilters: true,
            filterable: true,
            accessor: (cellProps) => {
                return (
                    <h5 className="mb-0 fs-16">{cellProps?.email}</h5>
                )
            },
        },
        {
            Header: "Send Date",
            disableFilters: true,
            filterable: true,
            accessor: (cellProps) => cellProps.createdAt ? moment(cellProps.createdAt).format('DD-MM-YYYY') : '-',
        },

        // {
        //     Header: "Edit Date",
        //     accessor: "updatedAt",
        //     disableFilters: true,
        //     filterable: true,
        //     accessor: (cellProps) => cellProps.updatedAt ? moment(cellProps.updatedAt).format('DD-MM-YYYY') : '-',
        // },

        // {
        //     Header: "Action",
        //     disableFilters: true,
        //     filterable: true,
        //     accessor: (cellProps) => {
        //         return (
        //             <ul className="hstack gap-2 list-unstyled mb-0">
        //                 <li>
        //                     <Button className="badge bg-primary-subtle text-primary edit-item-btn" data-bs-toggle="modal"
        //                         onClick={() => {
        //                             console.log('cellProps.id', cellProps.id)
        //                             setOpen(!open)
        //                             setfaqData(cellProps)
        //                         }}
        //                     >Edit</Button>
        //                 </li>
        //                 <li>
        //                     <Button data-bs-toggle="modal" className="badge bg-danger-subtle text-danger remove-item-btn" onClick={() => {
        //                         setfaqData(cellProps)
        //                         setShowModal(!showModal);
        //                     }}>Delete</Button>
        //                 </li>
        //             </ul>
        //         )
        //     },
        // },




    ]

    return (
        <React.Fragment>
            <div className="page-content">
                <Container fluid={true}>
                    <Breadcrumb title="News Letters" pageTitle="More" />
                    <div id="couponsList">
                        {/* <Row>
                            <Col xxl={12}>
                                <Card>
                                    <Card.Body>
                                        <Row className="align-items-center">
                                            <Col className="col-md-auto ms-auto">

                                                <Button variant='success' onClick={() => {
                                                    setOpen(!open)
                                                    setfaqData({})
                                                }} className="add-btn"><i className="bi bi-plus-circle me-1 align-middle"></i>Add FAQ</Button>
                                            </Col>
                                        </Row>
                                    </Card.Body>
                                </Card>
                            </Col>
                        </Row> */}

                        <Row>
                            <Col lg={12}>
                                <Card>
                                    <Card.Body className='p-0'>
                                        <TableContainer
                                            columns={(columns || [])}
                                            data={(listData?.response || [])}
                                            iscustomPageSize={false}
                                            isBordered={false}
                                            customPageSize={5}
                                            className="custom-header-css table align-middle table-nowrap"
                                            tableClass="table-centered align-middle table-nowrap mb-0"
                                            theadClass="text-muted table-light"
                                            SearchPlaceholder='Search Products...'
                                        />
                                        <div className="noresult" style={{ display: "none" }}>
                                            <div className="text-center">
                                                <h5 className="mt-2">Sorry! No Result Found</h5>
                                                <p className="text-muted mb-0">We've searched more than 150+ Orders We did not find any orders for you search.</p>
                                            </div>
                                        </div>

                                    </Card.Body>
                                </Card>
                            </Col>
                        </Row>
                    </div>

                    {/* {open &&
                        <CreateFaq open={open} setOpen={setOpen} faqData={faqData} />} */}
                    {/* {showModal && <DeleteModal showModal={showModal} setShowModal={setShowModal} data={{ name: faqData?.question }} handleSubmit={() => faqDeleteFunc({ id: faqData?.id })} />} */}
                </Container>
            </div>

        </React.Fragment >
    );
}

export default NewsLetterList; 